import { useState } from "react";
import { useLocation } from "react-router-dom";
import { HugeiconsIcon } from "@hugeicons/react";
import { CustomerSupportIcon } from "@hugeicons/core-free-icons";
import { SupportModal } from "@/components/SupportModal/SupportModal";

/**
 * Floating "Contact support" button anchored to the bottom-right. Click
 * opens a slide-up panel (see SupportModal) docked to the same corner —
 * NOT a centered Dialog — so users can keep working with the page
 * behind it.
 *
 * Hidden wherever the Inbox conversation panel renders (it crowds the
 * two-pane layout): the standalone `/inbox` route and Outreach's Inbox
 * tab (?tab=inbox — Campaigns is the default tab, so bare /outreach
 * keeps the bubble). Also gated off detail/editor pages in
 * PrivateLayoutWeb.
 */
export function SupportBubble() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  if (location.pathname.includes("/inbox")) {
    return null;
  }
  if (location.pathname.startsWith("/outreach")) {
    const tab = new URLSearchParams(location.search).get("tab");
    if (tab === "inbox") return null;
  }

  return (
    <>
      {/* Blue circle bubble — explicit size-12 rounded-full so it reads
          as a chat widget bubble rather than a generic button. Hidden
          while the panel is open so the two surfaces don't stack. */}
      {!isOpen && (
        <button
          type="button"
          onClick={() => setIsOpen(true)}
          aria-label="Contact support"
          title="Contact support"
          className="fixed bottom-6 right-6 z-50 inline-flex items-center justify-center size-12 rounded-full bg-primary text-primary-foreground shadow-lg shadow-primary/30 transition-all hover:bg-primary/90 hover:scale-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40"
        >
          <HugeiconsIcon icon={CustomerSupportIcon} size={22} />
        </button>
      )}

      <SupportModal open={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
